export default {
  notfound: {
    title: 'This page has not been generated',
    hint: 'Tell me more about this page, so I can generate it',
  },
};